<template>
  <v-container>
    <v-layout justify-center>
      <template v-if="$store.state.userId != ''">
        <v-flex md5>
          <v-card class="elevation-12 rounded-card">
            <v-toolbar dark color="primary">
              <v-toolbar-title justify-center>{{ signText }} </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-img :src="require('@/assets/logo.png')" contain></v-img>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
      <template v-else>
        <v-flex md5>
          <v-card class="elevation-12 rounded-card">
            <v-toolbar dark color="primary">
              <v-toolbar-title justify-center>Signin</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-img :src="require('@/assets/logo.png')" contain></v-img>
              <v-form>
                <div id="firebaseui-auth-container"></div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
        <div class="text-center">
          <v-dialog v-model="dialog" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Please stand by
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-layout>
  </v-container>
</template>
<script>
import firebase from "@/Firebase";
import { functions } from "@/Firebase";
import { db } from "@/Firebase";
import * as firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";

export default {
  name: "Signin",
  data: () => ({
    temp: [],
    dialog: false,
    signText: "You are signed in"
  }),
  mounted() {
    var vm = this;
    let uiConfig = {
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID
        },
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID
        }
      ],
      callbacks: {
        signInSuccessWithAuthResult: function(authResult) {
          vm.authChange(authResult);
          localStorage.setItem("saascadetechauthenticated", true);
        }
      }
    };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    ui.start("#firebaseui-auth-container", uiConfig);
  },
  computed: {
    authenticated() {
      if (this.$store.state.userId == "") return false;
      else return true;
    }
  },
  methods: {
    authChange(authResult) {
      var user = authResult.user;
      this.dialog = true;
      if (user) {
        var email = String(user.email);
        var uid = String(user.uid);
        this.$store.commit("addEmail", email);
        this.$store.commit("addUserId", uid);
        var isNewUser = authResult.additionalUserInfo.isNewUser;
        if (isNewUser) {
          this.signText = "Please wait, we'll setup your account";
          this.$store.commit("addDisplayName", user.displayName);
          var addUser = functions.httpsCallable("addUser");
          addUser({
            uid: uid,
            rfid: this.$store.state.rfid,
            currency: this.$store.state.currency,
            currencySymbol: this.$store.state.currencySymbol
          }).then(() => {
            this.dialog = false;
            window.location.href = "/profile";
          });
        } else {
          let usersRef = db.collection("users").doc(uid);
          usersRef.get().then(doc => {
            if (doc.exists) {
              this.temp.push(doc.data());
              this.$store.commit("addDisplayName", this.temp[0].displayName);
              this.$store.commit("addPhNumber", this.temp[0].phNumber);
              this.$store.commit("addAddress", this.temp[0].address);
              this.$store.commit("addCity", this.temp[0].city);
              this.$store.commit("addCountry", this.temp[0].country);
              this.$store.commit("addPostalCode", this.temp[0].postalCode);
              this.$store.commit("addCurrency", this.temp[0].currency);
              this.$store.commit(
                "addCurrencySymbol",
                this.temp[0].currencySymbol
              );
              this.$store.commit("addRfid", this.temp[0].rfid);
            }
          });
          let shortRef = db.collection("users").doc(uid);
          shortRef
            .collection("shortList")
            .get()
            .then(snapshot => {
              snapshot.forEach(doc => {
                let temp = doc.data();
                this.$store.commit("addShortList", temp);
                this.$store.commit("addShortListId", temp.id);
                this.$store.commit("addShortListDocId", doc.id);
              });
              this.dialog = false;
              window.location.href = "/";
            });
        }
      }
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 35px;
  background: light;
}
</style>
